<ew-mat-dialog-custom>
    <ew-mat-stepper-custom
    [validations]="validations"
    [alignItems]="'center'"
    (send)="requestProvider()"
    [sendIn]="'penultimate'">
    
    <ew-mat-stepper-custom-step>
        <div class="flex flex-col flex-nowrap items-center">
            <h1>{{'requestNewProvider:title' | translate}}</h1>
            <h2 class="mt-2 text-gray-400 font-normal">{{'requestNewProvider:subtitle' | translate}}</h2>
        </div>

        <div class="flex border border-gray-300 rounded-md p-2 mt-4">
            <div
                class="flex flex-col relative rounded-full w-10 h-10 min-w-10 bg-gray-200 justify-center items-center gt-xs:mr-4 mr-2"
                *ngIf="provider?.logo">
                <img class="w-10 rounded-full object-cover" [ngSrc]="provider.logo" alt="" fill />
            </div>
            <div class="grid xs:max-w-[75%] truncate">
                <span class="font-medium">{{ provider?.name }}</span>
                <small>{{ 'country:' + provider?.country?.toUpperCase() | translate }}</small>
            </div>
        </div>
          

        <form [formGroup]="form" class="flex flex-col h-full mt-5">
            <div class="flex gap-5">
                <mat-form-field class="w-full">
                    <mat-label>{{ 'requestNewProvider:contactName' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        id="name"
                        formControlName="name"
                        required />
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{ 'requestNewProvider:contactEmail' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        id="email"
                        formControlName="email"
                        required />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field class="w-full">
                    <mat-label>{{ 'requestNewProvider:emailLabel' | translate }}</mat-label>
                    <textarea
                        matInput
                        id="text"
                        formControlName="text"
                        required
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        class="whitespace-pre-wrap"
                    ></textarea>
                </mat-form-field>
            </div>
        </form>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
        <mat-progress-spinner
            class="m-auto my-5"
            [diameter]="24"
            [mode]="'indeterminate'"
            *ngIf="loading"></mat-progress-spinner>

        <div class="text-center grid gap-4 max-w-2xl" *ngIf="!loading">
            <img
            class="w-10 m-auto"
            width="150"
            src="assets/circle-check.svg"
            alt="" />
            <div class="mb-5 text-5xl font-bold">
            {{ 'requestNewProvider:sent' | translate }}
            </div>
            <div class="">
            {{ 'requestNewProvider:sentDisclaimer' | translate }}
            </div>
        </div>
    </ew-mat-stepper-custom-step>

    </ew-mat-stepper-custom>
</ew-mat-dialog-custom>